'use strict';
import { module } from '../app';

module.filter('propertyLevelLeftMargin', function () {
  return function (level) {
    return { 'margin-left': (level * 20) + 'px' };
  };
});


// WEBPACK FOOTER //
// ./src/scripts/filters/propertyLevelLeftMargin.js